import apiPayment from 'api/payment'
import { GETTING_NEW_LINK, SET_NEW_LINK_ERRORS, SAVE_NEW_PAYMENT_LINK, RESET_NEW_PAYMENT_LINK } from '../../../../types/conversations/plugins'


const gettingLink = (userId, gettingLink = true) => ({
  userId,
  gettingLink,
  type: GETTING_NEW_LINK,
})

const setNewLinkErrors = (userId, errors = {}) => ({
  userId,
  errors,
  type: SET_NEW_LINK_ERRORS,
})

const updateLink = (userId, link) => (dispatch) => {
  return dispatch({
    userId,
    link,
    type: SAVE_NEW_PAYMENT_LINK,
  })
}

const resetLink = (userId) => (dispatch) => {
  return dispatch({
    userId,
    type: RESET_NEW_PAYMENT_LINK,
  })
}

const renewLink = (user, orderId) => (dispatch) => {
  // dispatch getting link action and resetting errors
  dispatch(gettingLink(user.id))
  dispatch(setNewLinkErrors(user.id))

  return apiPayment
    .renewPaymentLink({ userId: user._id, orderId })
    .then(({ data, status }) => {
      // Important! We're not getting url anymore, update state.
      dispatch(gettingLink(user.id, false))

      if (status !== 200) return dispatch(setNewLinkErrors(user.id, data))
      else return dispatch(updateLink(user.id, data.url))
    })
    .catch((error) => {
      console.error('renewLink -> error', error) // log real error to the console
      dispatch(gettingLink(user.id, false))
      return dispatch(setNewLinkErrors(user.id, { error: 'server-error' }))
    })
}

export default {
  renewLink,
  resetLink,
}